import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login.js';
import Homeslider from './pages/homeslider/homeslider.js';
import Speakers from './pages/speakers/Speakers.js';
import Abstractupload from './pages/abstractupload/abstractupload.js';
import Aboutus from './pages/aboutus/aboutus.js';
import Uploadanalytics from './pages/uploadanalytics/uploadanalytics.js';
import Seocontent from './pages/seocontent/seocontent.js';
import Sociallinks from './pages/sociallinks/sociallinks.js';
import Videosgallery from './pages/videosgallery/videosgallery.js';
import Webinarevent from './pages/webinarevent/webinarevent.js';
import Webinarqa from './pages/webinarqa/webinarqa.js';
import Webinarvideo from './pages/webinarvideo/webinarvideo.js';
import Webinarwelcomecontent from './pages/webinarwelcomecontent/webinarwelcomecontent.js';
import Welcomecontent from './pages/welcomecontent/welcomecontent.js';
import Pastconfaffilations from './pages/pastconfaffilations/pastconfaffilations.js';
import Pastconfreport from './pages/pastconfreport/pastconfreport.js';
import Pastwebinarreport from './pages/pastwebinarreport/pastwebinarreport.js';
import Guidelines from './pages/guidelines/guidelines.js';
import TermsAndConditions from './pages/termsandconditions/termsandconditions.js';
import Regaddons from './pages/regaddons/regaddons.js';
import Registrationcontent from './pages/registrationcontent/registrationcontent.js';
import Registrationdates from './pages/registrationdates/registrationdates.js';
import Registrationtypeslist from './pages/registrationtypeslist/registrationtypeslist.js';
import Footers from './pages/footer/footer.js';
import Webinarprogram from './pages/webinarprogram/webinarprogram.js';
import Homeevent from './pages/homeevent/homeevent.js';
import Scientificprogram from './pages/scientificprogram/scientificprogram.js';
import Mediapartners from './pages/mediapartners/mediapartners.js';
import Ocm from './pages/ocm/ocm.js';
import Pastconftestimonials from './pages/pastconftestimonials/pastconftestimonials.js';
import Seoopengraphprotocol from './pages/seoopengraphprotocol/seoopengraphprotocol.js';
import Seoschemamarkup from './pages/seoschemamarkup/seoschemamarkup.js';
import Seotwittercard from './pages/seotwittercard/seotwittercard.js';
import Venue from './pages/venue/venue.js';
import Brochureuploads from './pages/brochureuploads/brochureuploads.js';
import Testimonials from './pages/testimonials/testimonials.js';
import Supportingjournals from './pages/supportingjournals/supportingjournals.js';
import Sessions from './pages/sessions/sessions.js';
import Seoxmlsitemap from './pages/seoxmlsitemap/seoxmlsitemap.js';
import Pastconfproceedingsupload from './pages/pastconfproceedingsupload/pastconfproceedingsupload.js';
import Pastconfgallery from './pages/pastconfgallery/pastconfgallery.js';
import Homecontact from './pages/homecontact/homecontact.js';
import SampleTextEditor from './pages/sampleTextEditor/sampleTextEditor.js';
import RegistrationPriceSetup from './pages/registrationpricesetup/registrationpricesetup.js';
import Conferenceqa from './pages/conferenceqa/conferenceqa.js';
import Abstractqa from './pages/abstractqa/abstractqa.js'

import { ToastContainer } from 'react-toastify';
const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/speakers" element={<Speakers />} />
      <Route path="/homeslider" element={<Homeslider />} />
      <Route path="/conferenceqa" element={<Conferenceqa />} />
      <Route path="/abstractqa" element={<Abstractqa />} />
      <Route path="/abstractupload" element={<Abstractupload />} />
      <Route path="/aboutus" element={<Aboutus />} />
      <Route path="/uploadanalytics" element={<Uploadanalytics />} />
      <Route path="/seocontent" element={<Seocontent />} />
      <Route path="/sociallinks" element={<Sociallinks />} />
      <Route path="/videosgallery" element={<Videosgallery />} />
      <Route path="/webinarevent" element={<Webinarevent />} />
      <Route path="/webinarqa" element={<Webinarqa />} />
      <Route path="/webinarvideo" element={<Webinarvideo />} />
      <Route path="/webinarwelcomecontent" element={<Webinarwelcomecontent />} />
      <Route path="/welcomecontent" element={<Welcomecontent />} />
      <Route path="/pastconfaffilations" element={<Pastconfaffilations />} />
      <Route path="/pastconfreport" element={<Pastconfreport />} />
      <Route path="/pastwebinarreport" element={<Pastwebinarreport />} />
      <Route path="/guidelines" element={<Guidelines />} />
      <Route path="/termsAndConditions" element={<TermsAndConditions />} />
      <Route path="/regaddons" element={<Regaddons />} />
      <Route path="/registrationcontent" element={<Registrationcontent />} />
      <Route path="/registrationdates" element={<Registrationdates />} />
      <Route path="/registrationtypeslist" element={<Registrationtypeslist />} />
      <Route path="/webinarprogram" element={<Webinarprogram />} />
      <Route path="/brochureuploads" element={<Brochureuploads />} />
      <Route path="/homeevent" element={<Homeevent />} />
      <Route path="/scientificprogram" element={<Scientificprogram />} />
      <Route path="/mediapartners" element={<Mediapartners />} />
      <Route path="/ocm" element={<Ocm />} />
      <Route path="/pastconftestimonials" element={<Pastconftestimonials />} />
      <Route path="/seoopengraphprotocol" element={<Seoopengraphprotocol />} />
      <Route path="/seoschemamarkup" element={<Seoschemamarkup />} />
      <Route path="/seotwittercard" element={<Seotwittercard />} />
      <Route path="/venue" element={<Venue />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/supportingjournals" element={<Supportingjournals />} />
      <Route path="/sessions" element={<Sessions />} />
      <Route path="/seoxmlsitemap" element={<Seoxmlsitemap />} />
      <Route path="/pastconfproceedingsupload" element={<Pastconfproceedingsupload />} />
      <Route path="/pastconfgallery" element={<Pastconfgallery />} />
      <Route path="/homecontact" element={<Homecontact />} />
      <Route path="/footers" element={<Footers />} />
      <Route path="/sampleTextEditor" element={<SampleTextEditor />} />
      <Route path="/regpricesetup" element={<RegistrationPriceSetup />} />
    </Routes>
    <ToastContainer />
  </Router>
);
export default AppRoutes;